{
  "ru": {
    "searchFormCalendar": {
      "selectedDateText": "Выбрать {date}",
      "selectedDatePriceText": {
        "OW": "от {price} туда",
        "RT": "от {price} туда и обратно"
      },
      "weekDays": {
        "monday": "пн",
        "tuesday": "вт",
        "wednesday": "ср",
        "thursday": "чт",
        "friday": "пт",
        "saturday": "сб",
        "sunday": "вс"
      }
    }
  },
  "kk": {
    "searchFormCalendar": {
      "selectedDateText": "{date} таңдау",
      "selectedDatePriceText": {
        "OW": "кемі {price} ұшу",
        "RT": "кемі {price} барып қайту"
      },
      "weekDays": {
        "monday": "дс",
        "tuesday": "сс",
        "wednesday": "сә",
        "thursday": "бс",
        "friday": "жм",
        "saturday": "сб",
        "sunday": "жс"
      }
    }
  },
  "en": {
    "searchFormCalendar": {
      "selectedDateText": "Select {date}",
      "selectedDatePriceText": {
        "OW": "from {price} to",
        "RT": "from {price} to and back"
      },
      "weekDays": {
        "monday": "Mon",
        "tuesday": "Tue",
        "wednesday": "Wed",
        "thursday": "Thu",
        "friday": "Fri",
        "saturday": "Sat",
        "sunday": "Sun"
      }
    }
  }
}
